<!--
================================================
Composant pour éditer un task timerecord
(copie du ModalTimerecordsEditionComp)


Url d'accès :
http://localhost:8080/fr/cronocloud-inc/timeTracking

Description :
     * Le timerecord passée au comp depuis le store est cloné dans un objet mutableTimerecord

// NOTE :  J'ai dû désactiver les input direct dans les dates picker allowInput, en effet au final je ne parvenais pas à maintenir une bonne synchro entre la valeur entrée directement dans l'input et celle envoyée.


LIMITATIONS :

  * Lorsque l'on modifie un tr qui n'a pas de tags et que l'on sélectionne des tags, .currentTag affiche toujours "aucun tag". 👉 https://gitlab.com/ousmane1/kronocloud/-/issues/758

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div id="ModalTaskTimerecordsEditionComp" class="modalTaskTrEdition"
       v-bind:class="{'darkMode':themeToDisplay=='dark'}">

    <div class="modal" id="modalTaskTrEdition"
         v-bind:class="{ 'is-active': isVisible }"
         v-on:keyup.esc="hide(), cancelTrEdit()" tabindex="0"
    >

      <!--ajouter la classe is-active sur.modal pour afficher-->
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title has-text-left">
            {{ $t('ModifierUnPointage') }} </p>
          <button v-on:click="toggleVisibility(), cancelTrEdit()" id="closeModalTaskTrEdit" class="delete"
                  aria-label="close"></button>
        </header>

        <!--         selecteur mode -->
        <div class="modeSelector">
          <a v-if="modalMode=='edit'" v-on:click="toggleModalMode()" id="modeSelectorButtonDelete"
             class="selector linkDelete"
             v-bind:title="$t('supprimerLePointage')">
            <font-awesome-icon class="icon" :icon="['fas', 'trash-alt']"/>
            {{ $t('supprimer') }}
          </a>

          <a v-else-if="modalMode=='delete'" v-on:click="toggleModalMode()" id="modeSelectorButtonEdit"
             class="selector linkEdit" v-bind:title="$t('modifierLePointage')">
            <font-awesome-icon class="icon" :icon="['fas', 'pencil-alt']"/>
            {{ $t('modifier') }}
          </a>
        </div>


        <section class="modal-card-body">

          <!-- mode edition-->
          <div v-if="modalMode=='edit'" class="editMode">
            <form action="" v-on:keyup.enter="validateBeforeSubmit">

              <div class="columns is-mobile">
                <div class="column">

                  <div class="field">

                    <input class="input taskName" type="text" v-bind:placeholder="$t('nomDeLaTâche')"
                           v-model="timerecord.taskName"
                           v-validate="'max:255'"
                           data-vv-validate-on="change"
                           name="taskEdit_taskName"
                           id="taskEdit_taskName"
                           v-bind:class="{'is-loading':isSubmiting}"
                    >
                    <p class="help is-danger has-text-left" id="error_taskEdit_taskName">
                      {{ errors.first('taskEdit_taskName') }}</p>

                  </div>
                </div>

                <!-- isBillable -------------------------------------------->
                <div class="column is-1-desktop is-2-mobile">
                  <div class="isBillable">
                    <div class="circle billableSelector"
                         v-bind:title="[isBillable ? $t('facturable') : $t('nonFacturable')]"
                         v-bind:class="{'on':isBillable}"
                         v-on:click="toggleIsBillable()">
                      <font-awesome-icon class="icon2" :icon="['fas', 'dollar-sign']"/>
                    </div>

                    <div class="legend">
                      <label class="label" v-if="isBillable">{{ $t('facturable') }}</label>
                    </div>
                  </div>


                </div>
              </div>


              <!--- TimeIn --------------------------------------------->
              <div class="field in">

                <label class="label" for="">
                  <font-awesome-icon class="icon" :icon="['fas', 'stopwatch']"/>
                  {{ $t('début') }}</label>
                <div class="control" id="controlTimeIn">
                  <flat-pickr v-model="timeInNewValue"
                              :config="config"
                              class="input"
                              v-bind:placeholder="$t('ChoisissezUneDateDeDébut')"
                              v-validate="{required:true}"
                              id="taskTrEditModal_timeIn"
                              name="taskTrEditModal_timeIn"

                  ></flat-pickr>

                </div>

                <p class="help is-danger has-text-left" id="error_taskTrEditModal_timeIn">
                  {{ errors.first('taskTrEditModal_timeIn') }} </p>

              </div>


              <!--- TimeOut --------------------------------------------->
              <div class="field out">
                <label class="label mt-5" for="">
                  <font-awesome-icon class="icon" :icon="['fas', 'stopwatch']"/>
                  {{ $t('fin') }}</label>

                <div class="control" id="controlTimeOut">

                  <flat-pickr v-model="timeOutNewValue"
                              :config="config"
                              v-on:open="onOpen()"
                              class="input"
                              v-bind:placeholder="$t('ChoisissezUneDateDeFin')"
                              v-validate="{required:(timerecordIsCurrent ? false : true)}"
                              id="taskTrEditModal_timeOut"
                              name="taskTrEditModal_timeOut"
                              @on-change="onChange()"


                  ></flat-pickr>
                </div>

                <p class="help is-danger has-text-left" id="error_taskTrEditModal_timeOut">
                  {{ errors.first('taskTrEditModal_timeOut') }}</p>
                <p class="help is-danger has-text-left" id="error_spe_after" v-show="clockoutBeforeClockin">
                  {{ $t('DateDeFinDoitEtrePostérieur') }}</p>


              </div>


              <!--- Duration --------------------------------------------->
              <div class="trInfos">

                            <span class=" duration is-pulled-right ">
                                <font-awesome-icon :icon="['fas', 'stopwatch']" class="icon"/>
                                <span> {{ $t('durée') }} : {{ duration }}</span>
                            </span>
              </div>


              <!--- Projects --------------------------------------------->
              <div class="projectSelectorSwitch">
                <label class="label mt-6" for="taskTrEditModal_project">
                  <!-- affiche le nom du projet sélectionné si existe-->
                  <span v-if="projectToAttach!== null" v-bind:title="$t('projet')" class="currentProject"
                        v-on:click="toggleProjectSelectorVisibility()">
                    <font-awesome-icon v-bind:style="{color:'#'+ projectToAttach.color}"
                                       class="icon switchProjectSelector_js" :icon="['far', 'folder-open']"/>
                    <span class="projectName switchProjectSelector_js">{{ projectToAttach.name }}</span>
                  </span>
                  <!-- sinon on affiche un lien pour ouvrir le sélecteur de projet-->
                  <span v-else class="opener switchProjectSelector_js">
                      <font-awesome-icon class="icon" :icon="['far', 'folder-open']"/>
                      <span v-on:click="toggleProjectSelectorVisibility()" v-bind:title="$t('choisirUnProjet')"
                            class="noProject  switchProjectSelector_js">{{ $t('aucunProjet') }}</span>
                  </span>

                </label>
                <project-selector-comp v-bind:component-source="$options.name"
                                       v-bind:allow-create-invite="false"></project-selector-comp>

              </div>

              <!--- Tags --------------------------------------------->
              <div class="tagSelectorSwitch">
                <label class="label mt-5" for="taskTrEditModal_tag">
                  <!-- affiche les tags sélectionné si existent-->

                    <span v-if="tagsToAttach!= null && tagsToAttach.length > 0" v-bind:title="$t('Tags')" class="currentTag is-clickable"
                        v-on:click="toggleTagSelectorVisibility()">
                     <span class="is-size-7 ml-2 is-inline switchTagSelector_js" ><font-awesome-icon :icon="['fas', 'tag']"/></span>
<!--                      <span class="mr-1 ml-1 switchTagSelector_js afterEditTrTags" v-if="tagsSlug4Patch !=null && tagsSlug4Patch.length > 0">| {{$tc('xTags',tagsSlug4Patch.length)}} </span>-->
                      <!-- Si aucun tag n'a été modifié par rapport à l'état de base du timerecord, on affiche le nombre de tags basé sur le timerecord-->
                      <span class="mr-1 ml-1 switchTagSelector_js afterEditTrTags" v-if="tagsSlug4Patch !=null && tagsSlug4Patch.length > 0">{{$tc('xTags',tagsSlug4Patch.length)}} </span>
                      <!-- sinon on affiche le nombre de tags cochés dans le sélecteur -->
                      <span v-else class="mr-1 ml-1 switchTagSelector_js currentTrTags">{{$tc('xTags',timerecord.tags.length)}} </span>

                  </span>
                    <!-- sinon on affiche un lien pour ouvrir le sélecteur de tag-->
                    <span v-else class="opener switchTagSelector_js ml-2" >
                        <font-awesome-icon class="icon mr-1" :icon="['fas', 'tag']"/>

                      <!-- Si aucun tag n'a été modifié par rapport à l'état de base du timerecord, on affiche le nombre de tags basé sur le timerecord-->
<!--                        <span class="mr-1 ml-1 switchTagSelector_js afterEditTrTags" v-if="tagsSlug4Patch !=null && tagsSlug4Patch.length > 0" v-on:click="toggleTagSelectorVisibility()">| {{$tc('xTags',tagsSlug4Patch.length)}} </span>-->

                      <!-- sinon on affiche le nombre de tags cochés dans le sélecteur -->
<!--                        <span v-else v-on:click="toggleTagSelectorVisibility()" v-bind:title="$t('choisirDesTags')"-->
                        <span  v-on:click="toggleTagSelectorVisibility()" v-bind:title="$t('choisirDesTags')"
                              class="noTag is-clickable switchTagSelector_js">{{ $t('aucunTag') }}</span>
                    </span>

                </label>
                <tag-selector-comp v-bind:component-source="$options.name" v-bind:initial-tags="timerecord.tags"
                                       v-bind:allow-create-invite="false"></tag-selector-comp>

              </div>

            </form>
          </div>

          <!-- // mode suppression-->
          <div v-else-if="modalMode=='delete'" class="deleteMode">

            <span class="warningDelete">{{ $t('EtesVousSurDeVouloirSupprimerLePointageSuivant') }}</span>

            <div class="recap">
              <div class="name">{{ timerecord.taskName }}</div>
              <div class="columns">
                <div class="column is-narrow timeIn"><span class="inconInOut in"></span>{{
                    $moment(timerecord.timeIn).tz(this.user.timezone).format('LLL')
                  }}
                </div>
                <div class="column is-narrow is-hidden-touch symbol"> ⟹</div>
                <div class="column is-narrow timeOut"><span class="inconInOut out"></span>
                  <span v-if="timerecord.timeOut != undefined">
                    {{ $moment(timerecord.timeOut).tz(this.user.timezone).format('LLL') }}
                  </span>
                  <span v-else>
                    {{ $t('encours...') }}
                  </span>
                </div>
                <div class="column is-narrow duration">
                  <font-awesome-icon :icon="['fas', 'stopwatch']" class="icon"/>
                  <span>
<!--                  {{ $t('durée') }} :-->
                  {{ duration }}</span>
                </div>
              </div>
            </div>

          </div>

          <!------------>


        </section>
        <footer class="modal-card-foot">
          <a v-on:click="toggleVisibility(), cancelTrEdit()" class="button is-text cancelLink"
             id="modalTaskTrEditCancelBtn">{{ $t("annuler") }}</a>

          <span v-if="modalMode=='edit'">
                  <a v-on:click="validateBeforeSubmit()" v-bind:class="{'is-loading':isSubmiting}"
                     v-bind:disabled="isSubmiting"
                     class="button is-primary validBtn " id="submitModalTaskTrEdit">{{ $t("valider") }}</a>
                  </span>
          <span v-else-if="modalMode=='delete'">
                  <a v-on:click="sendDeleteQuery" v-bind:class="{'is-loading':isSubmiting}"
                     v-bind:disabled="isSubmiting"
                     class="button is-danger validBtn validDeleteBtn "
                     id="submitModalTaskTrEditDelete">{{ $t("supprimer") }}</a>
                  </span>
        </footer>

      </div>

    </div>
  </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import SentryMixin from "../mixins/SentryMixin.js";
import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
import InterceptorMixin from "../mixins/InterceptorMixin.js";
import TimeMixin from "../mixins/TimeMixin.js";
import _ from 'lodash'
import ProjectSelectorComp from "@/components/ProjectSelectorComp";
import ImpersionationWarnComp from "@/components/ImpersonationWarningComp";
import ProjectColorSelectorComp from "@/components/ProjectColorSelectorComp";
import BillableFilterComp from "@/components/Reports/BillableFilterComp";
import ClientListComp from "@/components/ClientListComp";
import TagSelectorComp from "@/components/Tags/TagSelectorComp";
import TagComp from "@/components/Tags/TagComp";
import TrackingMixin from "@/mixins/TrackingMixin";

export default {
  name: 'ModalTaskTimerecordsEditionComp', //utile dans vue dev tool
  mixins: [TimeMixin, InterceptorMixin, SentryMixin, GlobalErrorNotification, TrackingMixin],
  components: {
    TagComp,
    TagSelectorComp,
    ClientListComp,
    BillableFilterComp,
    ProjectColorSelectorComp,
    ImpersionationWarnComp,
    ProjectSelectorComp
  },
  // props: [''],
  data: function () {
    return {

      modalMode: 'edit', // (edit/delete) mode d'utilisation de la modale
      timeInNewValue: null,   // la nouvelle date d'entrée
      timeOutNewValue: null,  // la nouvelle date de sortie
      clockoutBeforeClockin: false, // un bool qui indique si la date dans inputOut est antérieure à la date dans
      isBillable: false, // bool, indique si le task tr est facturable
      initialTaskname: null, // string, valeur du timerecord.taskname avant modification

      locale: this.$route.params.locale,
      isSubmiting: false, // indique si le formulaire est en cours de soumission

      // pour les composants où l'user est identifié ///////////////////////
      organizationSlug: this.$route.params.organization,
      userSlug: JSON.parse(this.$cookie.get('auth')).userSlug,

      projectToAttach: null, // Object project, le projet à rattacher au timerecord
      tagsToAttach: null, // Array d'objets tag, les tags à rattacher au timerecord
      tagsSlug4Patch: null ,// Array de slug de tags à envoyer dans la requête PATCH //@todo temporaire ?
      // =================================================================
    }
  },

  computed: {
    // computed props for store :
    ...mapState({
      user: state => state.user,
      isVisible: state => state.ModalTaskTimerecordsEditionComp.isVisible,
      timerecord: state => state.ModalTaskTimerecordsEditionComp.timerecord,
      timerecordIsCurrent: state => state.ModalTaskTimerecordsEditionComp.isCurrent,
      TaskTimerecordListCompTimerecords: state => state.TaskTimerecordListComp.timerecords,
      themeToDisplay: state => state.app.themeToDisplay
    }),


    // clone de l'ojet timerecord (du store) que l'on édite, je le copie le temps de le manipuler dans les champs datepicker car sinon cela affecte l'affichage dans le tableau TimerecordTableLineComp
    mutableTimerecord: {
      get: function () {
        return _.clone(this.timerecord)
      },

    },

    // la durée du timerecord (est mis à jour en temps réel pour donner un aperçu lors de l'édition)
    duration: {
      get: function () {
        let duration = this.calculateDuration(this.$moment, this.timeInNewValue, this.timeOutNewValue)
        return this.formatDuration(duration, this.$moment, this.locale)
      },
    }

    // la configuration pour flatpickr https://flatpickr.js.org/options/
    , config: {
      get: function () {
        return {
          wrap: false, // set wrap to true only when using 'input-group'
          altFormat: this.$datepickerI18nConf.altFormat, // le format de date affiché dans l'input, localisé car visible par l'user | ex 15 min avant noël : (fr) 25/12/19 23:45 (en) 12/25/19 11:45 PM .
          dateFormat: 'Y-m-d H:i:S', //  le format dans l'attribut value | ex : 2019-12-25 23:45:00 |
          altInput: true, //Show the user a readable date (as per altFormat), but return something totally different to the server.
          altInputClass: 'datepicker input',
          enableTime: true,
          minuteIncrement: 1,
          allowInput: false, //  Allows to enter a date directly in the input field
          locale: this.$datepickerI18nConf.locale, // locale for this instance only
          time_24hr: this.$datepickerI18nConf.time_24hr,
        }
      }
    }

  },

  watch: {

    // Quand le timerecord est chargé on remet projectToAttach à la valeur du projet du tr ou à la valeur  de l'option "aucun projet" (idem pour les tags)
    timerecord: function () {
      if (this.timerecord != null) {

        // si un projet existe dans le tr on le définit dans projectToAttach
        if (this.timerecord.project != null) {
          this.projectToAttach = this.timerecord.project
        } else {
          this.projectToAttach = null
        }

        // si des tags existent dans le tr on le définit dans tagsToAttach
        if (this.timerecord.tags.length > 0) {
          this.tagsToAttach = this.timerecord.tags
        } else {
          this.tagsToAttach = null
        }

        // on stocke (une fois ) la valeurs initialie du timerecord.tasKname (pour le restaurer en cas d'annulation de l'édition)
        this.backupTr(this.timerecord)

      }
    },

    mutableTimerecord: function () {
      // quand mutableTimerecord est updaté on mets à jour les valeurs timeInNewValue & timeOutNewValue pour hydrater les pickers, permet d'hydrater les datepicker et d'afficher la valeurs dans le timezone de l'utilisateur
      this.timeInNewValue = this.$moment(this.mutableTimerecord.timeIn).tz(this.user.timezone).format('Y-MM-DD HH:mm')

      if (this.timerecordIsCurrent) { // si on édite le tr en cours on définit la date de fin à null
        this.timeOutNewValue = null
      } else {
        this.timeOutNewValue = this.$moment(this.mutableTimerecord.timeOut).tz(this.user.timezone).format('Y-MM-DD HH:mm')

      }

    },
    isVisible: function () {
      // tracking mixpanel (affichage/masquage de la modale)
      if (this.isVisible === true) {
        this.ga4GlobalEventTrack('Task edition modal opened' , {})

        this.$mixpanel.track("[ModalTrEdit] opened",);
      }
    },

  },

  methods: {

    /**
     * À chaque fois que la date change on remet l'affichage du message d'erreur clockoutBeforeClockin à false ( car sinon le message ne se masque pas avant la validation du form alors qu'une date correcte peut avoir été sélectionnée entre temps)**/
    onChange() {
      this.clockoutBeforeClockin = false;
    },

    /*
     Toggle l'affichage de la modal
     */
    toggleVisibility() {
      if (this.isVisible === true) {
        this.hide()
      }
    },

    /*
    Toggle l'affichage de la modal en mode suppression
    */
    toggleModalMode() {
      if (this.modalMode == 'delete') {
        this.modalMode = 'edit'
      } else {
        this.modalMode = 'delete'
      }

    },

    /*
    Masque la modal
     */
    hide() {
      this.$store.commit('UpdateModalTaskTimerecordsEditionComp', {
        'isVisible': false,
        timerecord: this.timerecord,
        isCurrent: false
      })

      this.modalMode = 'edit' //reset du mode
    },


    /**
     * Retourne true si timeOut est une date supérieur à timeIn
     * @param timeIn
     * @param timeOut
     */
    timeOutIsAfter(timeIn, timeOut) {
      if (this.$moment(timeOut).isAfter(timeIn)) {
        this.clockoutBeforeClockin = false
        return true
      } else {
        this.clockoutBeforeClockin = true
        return false
      }
    },

    /**
     * Valide le form avant soumission
     * N'ayant pas réussi à traiter la contrainte de validation after via vu validate, c'est ici que l'on vérifie si la date de sortie est bien postérieure à la date d'entrée.
     **/
    validateBeforeSubmit() {

      let self = this;
      this.$validator.validateAll().then((result) => {
        if (result) { // si la validation. réussie


          if (!this.timerecordIsCurrent) { // si le pointage n'est pas en cours...

            // on vérifie la postérité de la date de fin à la date de début
            if (self.timeOutIsAfter(self.timeInNewValue, self.timeOutNewValue)) {
              this.sendEditQuery()
            }
          } else { //  si le pointage est en cours...
            if (_.isEmpty(this.timeOutNewValue)) { // s'il n'a pas de date de fin, pas de vérification de postérité
              this.sendEditQuery()
            } else { // s'il a une date de fin (il faut vérifier la postérité)
              if (self.timeOutIsAfter(self.timeInNewValue, self.timeOutNewValue)) {
                this.sendEditQuery()
              }
            }

          }

        } else { // si il y a des erreurs...
          self.$store.commit('UpdateGlobalNotificationComp', {
            'isVisible': true,
            'color': 'is-danger',
            'message': self.$t('leFormulaireContientDesErreurs')
          });
          // this.isSubmiting = false;
        }

      })
    }


    /**
     Formate date pour l'envoyer au format de l'api REST
     * définit le marquage json pur l'api REST
     * formate en UTC

     Le formatage est effectué avec moment (https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/)

     * @param date | {string} (au format 2019-08-19 10:45:00)
     * @return {{date: {month: number, year: number, day: number}, time: {hour: number, minute: number}}}
     */
    , formatDate(date) {

      // on créé une date au timezone de l'utilisateur
      let momentDate = this.$moment.tz(date, 'YYYY-MM-DD HH:mm:ss', this.user.timezone)//  vu sur https://stackoverflow.com/questions/15347589/format-date-in-a-specific-timezone

      // on envoie les dates en les convertissant en utc !
      return {
        date: {
          year: parseInt(momentDate.utc().format('Y')),
          month: parseInt(momentDate.utc().format('MM')),
          day: parseInt(momentDate.utc().format('DD'))
        },
        time: {
          hour: parseInt(momentDate.utc().format('HH')),
          minute: parseInt(momentDate.utc().format('mm'))
        }
      }
    }


    /**
     * Envoie la requête patch de modification
     * @return {Promise<{} | never>}
     */
    , sendEditQuery() {

      this.isSubmiting = true;

      let self = this

      // définition des params d'url obligatoires & facultatifs
      const params = {
        taskName: self.timerecord.taskName,
        timeIn: self.formatDate(self.timeInNewValue),
        timeOut: self.formatDate(self.timeOutNewValue),
        isBillable: self.isBillable,
      }
      if (self.projectToAttach == null) { // si 'aucun projet' on envoie un projet vide
        params.project = null
      } else { // sinon on envoie la valeur du slug du projet
        params.project = self.projectToAttach.slug
      }

      // if (self.tagsToAttach == null) { // si 'aucun tag' on envoie un tag vide
      if (self.tagsSlug4Patch == null) { // si 'aucun tag' on envoie un tag vide //@todo est-ce mieux cette ligne elle rend l'édition d'un tr sans tags fonctionelle
        params.tags = null
      } else { // sinon on envoie la valeur du slug du projet
        params.tags = self.tagsSlug4Patch
      }
  console.warn('tags envoyés dans le PATCH ' +params.tags)
      return self.$http
          .patch(`/organizations/${self.organizationSlug}/users/${self.userSlug}/timeRecords/${self.timerecord.slug}`
              , params,
              {headers: {Authorization: self.$auth.header()}}
          )
          .then(function (response) {
            self.hide()
            self.updateTimerecords(response.data)
            self.tagsSlug4Patch = null // reset pour éviter qu' après une édition de tags sur un tr puis réouverture du sélecteur de tag sur un autre, le compteur de tag ne soit plus à jour @todo tester

            self.$store.commit('UpdateGlobalNotificationComp', {
              'isVisible': true,
              'color': 'is-success',
              'message': self.$t('lePointageAÉtéModifié'),
              'duration': 3200
            });

            // on conserve le timerecord édité comme "en cours" dans la view trimetracking uniquement s'il n'a pas date de fin
            if (_.isEmpty(self.timeOutNewValue)) { // maj du tr en cours
              self.$store.commit('UpdateTimeTrackingViewCurrentTask', response.data)
              self.$root.$emit('current_timerecord_edited')
            } else {// vidage du current task timerecord dans le store si le timerecord édité a une date de fin
              self.$store.commit('UpdateTimeTrackingViewCurrentTask', null);

            }

            self.backupTr(self.timerecord)


            // tracking
            self.$mixpanel.track("Task timerecord edited", {"timerecord": self.timerecord.slug});
            self.ga4GlobalEventTrack('Task edited' , {})

            return {}
          })
          .catch(function (error) {
            // On catch ici sauf ce qui relève des intercepteurs Axios
            if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
              self.logToSentry(self, error, 'error')

              let errorCode = '0024'
              self.showGlobalErrorNotif(self, errorCode)
              self.$mixpanel.track('global error displayed', {
                "id": errorCode,
                "detail": "error editing task timerecord"
              })
              self.$gtag.exception({
                'description': 'error ' + errorCode + ' | error editing task timerecord',
                'fatal': false
              })

              self.$sentry.captureMessage(`Error ${errorCode} > error on editing task timerecord : ${error}`, 'error')
            }
          })
          .then(function () {
            self.isSubmiting = false;
          })
    }

    /**
     * Envoie la requête de suppression
     * @return {Promise<{} | never>}
     */
    , sendDeleteQuery() {

      this.isSubmiting = true;
      let self = this

      return self.$http
          .delete(`/organizations/${self.organizationSlug}/users/${self.userSlug}/timeRecords/${self.timerecord.slug}`,
              {headers: {Authorization: self.$auth.header()}}
          )
          .then(function (response) {
            self.hide()
            self.updateTimerecords()
            self.backupTr(null)

            self.$store.commit('UpdateGlobalNotificationComp', {
              'isVisible': true,
              'color': 'is-success',
              'message': self.$t('lePointageAÉtéSupprimé'),
              'duration': 3200
            });

            // si le timerecord supprimé était en cours on le supprime de la vue
            if (_.isEmpty(self.timeOutNewValue)) { // maj du tr en cours
              self.$store.commit('UpdateTimeTrackingViewCurrentTask', null)
            }

            // tracking
            self.$mixpanel.track("Task timerecord deleted", {});
            self.ga4GlobalEventTrack('Task timerecord edited' , {})

            return {}
          })
          .catch(function (error) {
            // On catch ici sauf ce qui relève des intercepteurs Axios
            if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
              self.logToSentry(self, error, 'error')

              let errorCode = '0050'
              self.showGlobalErrorNotif(self, errorCode)
              self.$mixpanel.track('global error displayed', {
                "id": errorCode,
                "detail": "error deleting task timerecord"
              })
              self.$gtag.exception({
                'description': 'error ' + errorCode + ' | error deleting task timerecord',
                'fatal': false
              })
              self.$sentry.captureMessage(`Error ${errorCode} > error on deleting task timerecord : ${error}`, 'error')
            }
          })
          .then(function () {
            self.isSubmiting = false;
          })
    }

    /**
     * Met le store à jour avec editedTimerecord dans le cas d'une modification ou le supprime dans le cas d'une suppression
     * Cela permet que le timerecord modifié/supprimé soit mis à jour dans MyRecentActivityComp
     *
     * inspiré de https://stackoverflow.com/questions/27641731/is-there-a-function-in-lodash-to-replace-matched-item
     *
     * @param editedTimerecord object le timerecord mis à jour (retourné par l'api REST) dans sendEditQuery()
     *
     */
    , updateTimerecords(editedTimerecord) {


      // Find item index using _.findIndex
      var index = _.findIndex(this.TaskTimerecordListCompTimerecords, {slug: this.timerecord.slug});

      // Replace item at index using native splice
      if (editedTimerecord != undefined) { // mode edition (on remplace le tr édité)
        this.TaskTimerecordListCompTimerecords.splice(index, 1, editedTimerecord);
      } else { // mode suppression
        this.TaskTimerecordListCompTimerecords.splice(index, 1);
      }

    }



    /**
     * Toggle isBillable
     */
    , toggleIsBillable() {
      if (this.isBillable === true) {
        this.isBillable = false
      } else {
        this.isBillable = true
      }

    },

    /**
     * Créé une sauvegarde du timerecord pour pouvoir le restaurer en cas d'annulation de la modificaiton
     */
    backupTr(timerecord) {
      if (timerecord == null) {
        this.initialTaskname = null
      } else {
        this.initialTaskname = timerecord.taskName
      }
    },

    /**
     * Annule l'édition en remettant le nom du timerecord tel qu'il était avant modification
     */
    cancelTrEdit() {
      this.timerecord.taskName = this.initialTaskname
    },

    /**
     * Toggle la visbilité du composant projectSelectorComp
     */
    toggleProjectSelectorVisibility() {
      this.$root.$emit('toggle_project_selector_visibility', this.$options.name)
    },
    /**
     * Toggle la visbilité du composant tagSelectorComp
     */
    toggleTagSelectorVisibility() {
      this.$root.$emit('toggle_tag_selector_visibility', this.$options.name)
    },


  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  // updated: function(){},
  mounted: function () {

    this.backupTr(this.timerecord);

    // Listener écoutant la sélection d'un projet dans ProjectSelectorComp
    this.$root.$on('project_selected', (project, source) => {
      if (source == this.$options.name) { // on vérifie que le projet à bien été sélectionné dans le ProjectSelectorComp du composant actuel
        this.projectToAttach = project
      }
    })

    // Listener écoutant la sélection des tags dans TagSelectorComp
    this.$root.$on('tags_selected', (tags, source) => {
      if (source == this.$options.name) { // on vérifie que les tags ont bien étés sélectionné dans le TagSelectorComp du composant actuel
        // this.tagsToAttach.push(tag) //@todo génère une erreur pourquoi ! @todo utile ?!
        // ⚠️  ICI TAG VAUT UN ARRAY DE SLUG TAG @todo gérer, renomer en tags !?
        console.debug(` 🧪 tags_selected déclenché (🍥 depuis ${source} ) => il faut envoyer les tags : `+tags)
        this.tagsSlug4Patch = tags

      }
    })
  },


}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/css/globalVar.scss";
/*@import "../assets/css/bulmaResponsiveDep.scss";*/


.modalTaskTrEdition {


  .modal {

    // DATEPICKER -----------------------------------------------
    .datepicker {
      color: $brandThird;
      padding: 1.4rem !important;
    }

    color: $brandFourth;

    .modal-card-title {

    }

    .modal-card-body {
      padding-top: 0; // surcharge de la modale pour laisser de la place au .modeSelector
    }

    .trInfos {

      font-size: 0.85rem;
      font-weight: bold;

      .icon {
        color: #e2e6e7;
        height: 1rem;
      }

      .slug {
        .id {
          margin-left: 0.5rem;
          border-radius: 2px;
          background: #e2e6e7;
          color: white;
          padding: 0.1rem 0.4rem;
        }
      }

    }

    .projectSelectorSwitch {

      .icon {
        margin: 0 0.3rem 0 0.5rem
      }

      .opener {
        cursor: pointer !important;
      }

      .currentProject {
        font-size: 0.9rem;
        cursor: pointer;

      }
    }

    form {
      margin-top: 2rem;

      $size: 0.85rem;

      .icon {
        height: $size
      }

      .label {
        font-size: $size;
        color: $brandFourth;
        //margin-top: 2rem;
      }

      .field.in {

        .label {
          color: $brandPrimary;
        }

        .icon {
          color: $brandPrimary;
        }
      }

      .field.out {
        .label {
          color: $brandRed;
        }

        .icon {
          color: $brandRed
        }
      }

      .input {
        color: $brandFourth;
      }

      .field.comment {
      }

    }

    .isBillable {
      cursor: pointer;
      margin-top: 0.2rem;

      .label {
        cursor: pointer;
        font-size: 0.65rem;
        font-weight: normal;
        margin: 0;
      }

      .circle {
        width: 2.5rem;
        height: 2.5rem;
        background: #f4f4f4;
        border-radius: 1.2rem;
        transition: background-color 200ms ease-in-out;


        .icon2 {
          color: #ccc;
          font-size: 1.2rem;
          margin: 0.6rem auto 0 0.9rem;

          &:hover {
            color: darken(#ccc, 5%)
          }
        }

        &.on {
          background: #e9f4ce !important;

          .icon2 {
            color: $brandPrimary;
          }
        }
      }

      .legend {
        min-height: 1rem;
        margin: 0.4rem 0 0;
      }
    }


    .modeSelector {
      background-color: white;
      padding: 0 0.5rem;
      text-align: right;

      a {
        font-size: 0.85rem;
        font-weight: bold;
        padding: 0.6rem 0.6rem 0 0.6rem;
        display: inline-block;

        & .icon {
          margin: 0 0.2rem 0.1rem;
          height: auto;

        }
      }

      .selector {

        &.linkDelete {
          color: $brandRed;
        }

        &.linkEdit {
          color: #999;
        }
      }
    }

    .deleteMode {
      padding-top: 2rem;

      .warningDelete {
        font-size: 0.95rem;
        font-weight: bold;
        color: $brandRed;
      }

      .recap {
        margin: 1rem auto 2rem;
        border-left: solid 4px $brandRed;
        padding: 1rem;
        font-size: 0.9rem;
        background-color: #f9f9f9;

        .name {
          font-weight: bold;
          font-size: 1.1rem;
          margin: 0 1rem 0.5rem 0;
        }

        .symbol {
        }

        .duration {
          .icon {
            height: auto;
            width: 0.8rem;
          }
        }

        .inconInOut {

          display: inline-block;
          border: none;
          $size: 0.4rem;
          width: $size;
          height: $size;
          border-radius: 30px;
          margin-right: 0.3rem;

          &.in {
            background: $brandPrimary
          }

          &.out {
            background: $brandRed

          }
        }

      }
    }

  }

  //////////////////////////////////////
  // DARK UI ///////////////////////////
  &.darkMode {

    .isBillable {
      .circle {
        background-color: darken($darkBg, 10%);

        .icon2 {
          color: #ccc;

          &:hover {
            color: darken(#ccc, 5%)
          }
        }

        &.on {
          background-color: desaturate($brandPrimary, 10%) !important;

          .icon2 {
            color: $darkBg;
          }
        }
      }
    }

    .modeSelector {
      background-color: $darkBg;

      .selector {
        background-color: transparent !important;

        &.linkDelete {
          color: $darkBrandRed !important;
        }

        &.linkEdit {
          color: $darkTxt;
        }
      }
    }

    .deleteMode {

      .warningDelete {
        color: $darkBrandRed;
      }

      .recap {
        background-color: darken($darkBg, 3%);

        color: $darkTxt;

        .name {
        }

        .symbol {
        }

        .duration {
        }


      }
    }


  }
}


</style>
